import {Container, Singleton} from 'typescript-ioc'
import Advertisement from "@/module/ad/Advertisement";
import BaseApi from "@/api/BaseApi";
import {BasePqForm} from "biz-ts/src/api/Paging";
import ObjectUtil from "tools-ts/src/util/ObjectUtil";
import _ from 'lodash'

export class AdPagingForm extends BasePqForm {
    id?: string = ''
    tag = ''
    tags: Array<string> = []
    url?: string = ''
}

export interface AdSaveForm {
    id?: number;
    tag: string;
    url: string;
    imgUrl: string;
}

export abstract class BaseAdSaveForm implements AdSaveForm {
    id? = -1
    tag = ''
    url = ''
    imgUrl = ''
}

export class AdCreateForm extends BaseAdSaveForm {
}

export class AdEditForm extends BaseAdSaveForm {
}

@Singleton
export default abstract class AdvertisementApi {

    abstract paging(form: AdPagingForm): Promise<Array<Advertisement>>

    abstract create(form: AdCreateForm): Promise<void>

    abstract edit(form: AdEditForm): Promise<void>

    abstract delete(id: number): Promise<void>
}

export class AdvertisementApiImpl extends BaseApi implements AdvertisementApi {

    protected urlPrefix = 'advertisement'

    paging(form: AdPagingForm): Promise<Array<Advertisement>> {
        const f = ObjectUtil.deepClone(form)
        if (_.isEmpty(f.id))
            f.id = undefined
        if (!_.isEmpty(f.tag))
            f.tags.push(f.tag)
        if (_.isEmpty(f.url))
            f.url = undefined
        return this.axios.post('paging', f)
    }

    create(form: AdCreateForm): Promise<void> {
        return this.axios.post('create', form)
    }


    edit(form: AdEditForm): Promise<void> {
        return this.axios.post('edit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }

}

Container.bind(AdvertisementApi).to(AdvertisementApiImpl)
